import React from 'react';
export function CyberBackground() {
  return <>
      {/* Cyber Globe Background Image */}
      <div className="fixed inset-0 z-0" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/7oHDarj7gBkRu6Qenxbzv8/mario-verduzco-grH6lq1PXbo-unsplash.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed'
    }} data-id="element-649">
        {/* Dark overlay for readability */}
        <div className="absolute inset-0 bg-slate-950/85 backdrop-blur-sm" data-id="element-650"></div>

        {/* Gradient overlay for depth */}
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950/50 via-transparent to-slate-950/80" data-id="element-651"></div>

        {/* Cyan glow effect */}
        <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 via-transparent to-cyan-500/5" data-id="element-652"></div>
      </div>

      {/* Animated scanline effect */}
      <div className="fixed inset-0 z-0 pointer-events-none opacity-10" data-id="element-653">
        <div className="absolute inset-0 bg-[linear-gradient(to_bottom,transparent_50%,rgba(6,182,212,0.03)_50%)] bg-[length:100%_4px] animate-pulse" data-id="element-654"></div>
      </div>

      {/* Subtle grid overlay */}
      <div className="fixed inset-0 z-0 pointer-events-none opacity-5" data-id="element-655">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(6,182,212,0.1)_1px,transparent_1px),linear-gradient(to_bottom,rgba(6,182,212,0.1)_1px,transparent_1px)] bg-[size:40px_40px]" data-id="element-656"></div>
      </div>
    </>;
}